import './App.css';
import Navigation from './Components/Navigation';
import HeroSection from './Components/Hero';

const App = () => {
  return(
    <div>
      <Navigation/>
      <HeroSection/>
    </div>
  )
}
 
export default App;